"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Declarative_1 = require("../../utils/Declarative");
var SliderStyles_1 = require("./SliderStyles");
function calculateTickProportionalPositions(tickCount) {
    var tickPositionsAsProportions = [];
    if (tickCount === 1) {
        tickPositionsAsProportions.push(0.5);
    }
    else if (tickCount > 1) {
        // We subtract 1 from tickCount to make the final division below result in exactly 1.
        // For example, if tickCount === 4:
        // * (dividing by tickCount):     [0, 0.25, 0.5,  0.75]
        // * (dividing by tickCount - 1): [0, 0.33, 0.66, 1.0]
        // We want to position the marks like the later.
        var tickCountForSpacing = tickCount - 1;
        for (var i = 0; i < tickCount; i++) {
            tickPositionsAsProportions.push(i / tickCountForSpacing);
        }
    }
    return tickPositionsAsProportions;
}
exports.calculateTickProportionalPositions = calculateTickProportionalPositions;
/**
 * The tick bar is a bar, of ticks.  It is not interactive.
 */
function SliderTickBarWidget(props) {
    var tickPositionsAsProportions = calculateTickProportionalPositions(props.tickCount);
    var tickPositionsAsPercentages = tickPositionsAsProportions.map(function (x) { return x * 100; });
    var styles = SliderStyles_1.getSliderTickBarStyles();
    return (React.createElement("div", { style: styles.Bar, "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'SliderTickBar') }, tickPositionsAsPercentages.map(function (tickPositionAsPercentage, i) {
        return React.createElement("span", { key: i, style: tslib_1.__assign(tslib_1.__assign({}, styles.Tick), { left: tickPositionAsPercentage + "%" }) });
    })));
}
exports.SliderTickBarWidget = SliderTickBarWidget;
//# sourceMappingURL=SliderTickBarWidget.js.map